export default __webpack_public_path__ + "static/media/aliexpress.3c08d430.svg";